import React from 'react';
import { CheckIcon, XIcon, ArrowRightIcon } from 'lucide-react';
interface CheckItemProps {
  children: React.ReactNode;
  type?: 'check' | 'cross' | 'arrow' | 'none';
  emoji?: string;
  className?: string;
}
export function CheckItem({
  children,
  type = 'check',
  emoji,
  className = ''
}: CheckItemProps) {
  return <li className={`flex items-start gap-3 ${className}`} data-id="element-1">
      {emoji ? <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-2">{emoji}</span> : type === 'check' ? <CheckIcon className="w-6 h-6 flex-shrink-0 mt-1 text-emerald-500" data-id="element-3" /> : type === 'cross' ? <XIcon className="w-6 h-6 flex-shrink-0 mt-1 text-rose-500" data-id="element-4" /> : type === 'arrow' ? <ArrowRightIcon className="w-6 h-6 flex-shrink-0 mt-1 text-indigo-500" data-id="element-5" /> : null}
      <span className="text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-6">
        {children}
      </span>
    </li>;
}